import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { SummaryReport } from 'schemas/SummaryReport.schema.ts';
import { apiFetch } from 'utils/apiUtils';

interface IFetchSummaryReportVariables {
  teamId: string,
  campaignId: string,
  iterationId: string,
}

export default function useFetchSummaryReport({ teamId, campaignId, iterationId }: IFetchSummaryReportVariables) {
  const { tokens } = useAuth();
  return useQuery({
    queryKey: ['summary_report', { teamId, campaignId, iterationId }],
    queryFn: async (): Promise<SummaryReport[]> => {
      const reports = await apiFetch<SummaryReport[]>({
        path: `team/${teamId}/campaign/${campaignId}/iteration/${iterationId}/summary_report`,
        method: 'GET',
        accessToken: String(tokens.accessToken),
      });

      return reports
        .toSorted((a, b) => ((a.run_time ?? '') > (b.run_time ?? '') ? 1 : -1));
    },
  });
}
